import { useAppServices } from "hook/services";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const EventDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { event } = location.state || {};
  const AppService = useAppServices();
  const [applicants, setApplicants] = useState([]);
  const params = useParams();


  const viewApplicants = async (event) => {
    const { response } = await AppService.accounts.applyForEvent({
      query: `event_id=${encodeURIComponent(params.id)}`, // Encode for safety
    });

    console.log(response,"response")

    setApplicants(response?.data || []);
  };

  useEffect(() => {
    if (event) {
      viewApplicants(event);
    }
  }, [event]);

  if (!event) {
    return (
      <p style={{ textAlign: "center", fontSize: "18px", color: "#888" }}>
        No event details available.
      </p>
    );
  }

  return (
    <div style={{ padding: "20px", fontFamily: "'Arial', sans-serif", color: "#333",display: "flex", justifyContent:"space-between", flexDirection:"column" }}>
     <button
        onClick={() => navigate(-1)}
        style={{
          display: "block",
          padding: "10px 20px",
          fontSize: "16px",
          color: "#fff",
          backgroundColor: "black",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
          width: "fit-content",
        }}
      >
        Back
      </button>
     
      <h1 style={{ textAlign: "center", marginBottom: "20px" }}>Event Detail</h1>

      <div
        style={{
          border: "1px solid #ddd",
          borderRadius: "8px",
          padding: "20px",
          marginBottom: "30px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <h2 style={{ fontSize: "24px", marginBottom: "10px" }}>{event.event_name}</h2>
        <p style={{ fontSize: "16px", margin: "5px 0" }}>
          <strong>Date:</strong> {event.event_date}
        </p>
        <p style={{ fontSize: "16px", margin: "5px 0" }}>
          <strong>Start Time:</strong> {event.event_start_time}
        </p>
        <p style={{ fontSize: "16px", margin: "5px 0" }}>
          <strong>End Time:</strong> {event.event_end_time}
        </p>
        <p style={{ fontSize: "16px", margin: "5px 0" }}>
          <strong>Description:</strong> {event.event_description}
        </p>
        {event.image && (
          <div style={{ marginTop: "20px", textAlign: "left" }}>
            <img
              src={event.image}
              alt={event.event_name}
              style={{ maxWidth: "200px", height: "auto", marginTop: "10px", borderRadius: "8px" }}
            />
          </div>
        )}
      </div>

      {/* <div style={{ marginBottom: "30px", padding:"10px"}}>
        <h3 style={{ fontSize: "20px", marginBottom: "10px" }}>Interested Applicants</h3>
        {applicants && applicants.length > 0 ? (
          <ul style={{ padding: "0", listStyleType: "none" }}>
            {applicants.map((applicant, index) => (
              <li
                key={index}
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: "15px",
                  marginBottom: "10px",
                  backgroundColor: "#fff",
                }}
              >
                <p style={{ fontSize: "16px", margin: "5px 0" }}>
                  <strong>Name:</strong> {applicant?.account_id?.first_name}{" "}
                  {applicant?.account_id?.last_name}
                </p>

                <p style={{ fontSize: "16px", margin: "5px 0" }}>
                  <strong>Business Name:</strong> {applicant?.account_id?.business_name}
                </p>

                <p style={{ fontSize: "16px", margin: "5px 0" }}>
                  <strong>Interested</strong> {applicant?.interested ? "Yes":"No"}
                </p>

                <p style={{ fontSize: "16px", margin: "5px 0" }}>
                  <strong>Going</strong> {applicant?.going ? "Yes":"No"}
                </p>
              </li>
            ))}
          </ul>
        ) : (
          <p style={{ fontSize: "16px", color: "#888" }}>
            No interested applicants for this event.
          </p>
        )}
      </div> */}

      
    </div>
  );
};

export default EventDetail;
